import { Record } from "./recordApi";

const missingText = "(!)";

export class NameHelper {
    constructor ({ helpers, form, action }) {
        this.helpers = helpers;
        this.form = form;
        this.action = action;
    }

    getPropertyName (propertyIDSettingName) {
        const { helpers, action } = this;
        const propertyID = action.Settings[propertyIDSettingName];
        const propertyName = propertyID ? helpers.getEntityNameByID(app.dv.cache.properties.allProperties, propertyID, missingText) : "";
        return propertyName;
    }

    getFormName (formIDSettingName) {
        const { helpers, action } = this;
        const formID = action.Settings[formIDSettingName];
        const formName = formID ? helpers.getEntityNameByID(app.dv.cache.views.allViews, formID, missingText) : "";
        return formName;
    }

    getTaskName (formIDSettingName, taskIDSettingName) {
        const { helpers, form, action } = this;
        const formID = formIDSettingName ? action.Settings[formIDSettingName] : form.ViewID;
        const formName = formID ? helpers.getEntityNameByID(app.dv.cache.views.allViews, formID, missingText) : "";
        const taskID = action.Settings[taskIDSettingName];
        let taskName = taskID ? helpers.getChainFromView(form, formID, taskID, missingText) : "";
        if (formName) {
            taskName = `${formName}.${taskName}`;
        }
        if (taskName === missingText) {
            taskName = "";
        }
        return taskName;
    }

    getVariableName (variableSettingName) {
        const { helpers, form, action } = this;
        const variableName = action.Settings[variableSettingName];
        return api.environment.getFullVariableName(variableName);
    }
}

export class ExpressionHelper {
    constructor ({ form, action }) {
        this.form = form;
        this.action = action;
    }

    /**
     * Executes the expression for the specific setting of the current action and returns the result
     * @param {String} settingName - The name of the expression setting property on the action to get the value of.
     * @param {Record} [record = form.selectedRecord] - The API-wrapped record to evaluate the expression against. Defaults to the current selected record.
     * @returns {*} The result from the expression, or null if an error occurred.
     */
    getExpressionValue (settingName, record) {
        const { form, action } = this;
        if (record != null) {
            if (record instanceof Record) {
                record = record.raw;
            }
            else {
                console.warn('DEPRECATED: api.actionHelpers.getExpressionValue received an object that is not an instance of an API record.');
            }
        }
        let expression;
        try {
            // Create the expression
            expression = app.dv.mvc.createExpression(form, action.actionChainID, action.stepID, 0, null, form.drivingView.ViewID, action.Settings[settingName], null);
        } catch (e) {
            if (app.designer) {
                app.browser.notifier.showToast(`Error creating action expression:<br/>${action.Settings[settingName]}<br/>Error: ${e.message}`);
            }
            return null;
        }

        try {
            // Evaluate the expression
            return expression.evaluate(form.drivingView.ViewID, record || form.selectedRecord);
        } catch (e) {
            if (app.designer) {
                app.browser.notifier.showToast(`Error evaluating action expression:<br/>${action.Settings[settingName]}<br/>Error: ${e.message}`);
            }
            return null;
        }
    }
}

export class ExecutionHelper {
    constructor ({ options, callback, form, action }) {
        this.form = form || (options && options.context && options.context.view ? options.context.view.raw : null);
        this.action = action || (options ? options.action : null);
        this.callback = callback;
        this._resolved = false;
        this._rejected = false;
    }

    createResultAndCallback (success, continueExecution, message) {
        const result = new app.dv.actionLibrary.result(success, continueExecution);
        result.actionMessage = message;
        if (this.callback) {
            this.callback(result);
        }
        return result;
    }

    resolve (message) {
        if (this._allowCallbackResolution()) {
            this._resolved = true;
            return this.createResultAndCallback(true, true, message);
        }
    }

    reject (message) {
        if (this._allowCallbackResolution()) {
            this._rejected = true;
            return this.createResultAndCallback(false, false, message);
        }
    }

    _allowCallbackResolution() {
        if (this._resolved || this._rejected) {
            const actionName = this.action && this.action.Definition && this.action.Definition.Metadata && this.action.Definition.Metadata.Name ||
                "[could not determine action name]";
            const warningMessage = `This instance of Custom Action ${actionName} was previously ${this._resolved ? "resolved" : "rejected"}. The developer of the Custom Action should ensure that it is only resolved or rejected once.`;
            app.browser.notifier.showToast(warningMessage);
            return false;
        } else {
            return true;
        }
    }
}

/**
 * Returns the name of the specified task from the specified form.
 * @param {Object|Number} formID - The ID or linker object of the form to search.
 * @param {Number} taskID - The ID of the task to find.
 * @param {String} [nameIfNull] - A string to use if the view or task is not found.
 * @returns {String|null} The task name if it was found, or the specified default string, or null
 */
export function getTaskNameFromForm (formID, taskID, nameIfNull) {
    let forForm = null;
    // Get the form object from the edited copy, if it exists (i.e. the designer has edited this form)..PW
    if (app.designer && app.designer.monitor) {
        // Check the cache of edited form first..PW
        forForm = app.designer.monitor.editingViews.getVal(formID);
    }

    if (forForm == null) {
        // The target form was not found in the edited forms cache, check the entire cache..PW
        forForm = app.dv.cache.views.allViews.getVal(formID);
    }

    if (forForm != null && forForm.Definition.ViewMacros != null){
        // Got the form and it has tasks in it; look for the task..PW
        const targetTask = forForm.Definition.ViewMacros.find(c => c.MacroID === taskID);
        if (targetTask != null){
            return targetTask.Label;
        } else{
            return nameIfNull;
        }
    } else {
        return nameIfNull;
    }
}
